<template lang="pug">
	section#cronograma
		.wrapper
			img(src="@images/prouniHome/cronograma-full.png")
			.cronograma
				h1 #[span FIQUE LIGADO] NO CRONOGRAMA DE INSCRIÇÃO
				p.title Inscrições
				p 23/07/24 a 26/07/24
				//- p.title#aprovados Resultado da 1ª chamada
				a.title#aprovados(href="/Pré-selecionados_EAD_1_chamada.pdf" target="_blank") Pré-Selecionados 1ª chamada 
				//- a.title#aprovados(href="#" target="_blank") Aprovados da 1ª chamada
				p 31/07/24
				a.title#aprovados(href="/Aprovados_1_chamada.pdf" target="_blank") Resultado da 1ª chamada
				//- a.title#aprovados(href="#" target="_blank") Aprovados da 1ª chamada
				a.title#aprovados(href="/pre-selecionado-2-chamada-2024.pdf" target="_blank") Pré-Selecionados 2ª chamada
				//- p.title#aprovados Pré-Selecionados 2ª chamada
				p 30/08/24
				//- p.title#aprovados Resultado da 2ª chamada
				a.title#aprovados(href="/aprovados-2-chamada.pdf" target="_blank") Resultado da 2ª chamada
				p 17/09/24
				//- a.title#aprovados(href="#" target="_blank") Resultado da 2ª chamada
				//- a.title#aprovados(href="#" target="_blank") Aprovados da 2ª chamada
</template>

<script>
export default {
	name: "section-cronograma"
}
</script>

<style lang="stylus" scoped src="./Cronograma.styl"></style>
